import { render } from "./RemoteForm.vue?vue&type=template&id=2cfc8d26&scoped=true"
import script from "./RemoteForm.vue?vue&type=script&lang=js"
export * from "./RemoteForm.vue?vue&type=script&lang=js"

import "./RemoteForm.vue?vue&type=style&index=0&id=2cfc8d26&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cfc8d26"]])

export default __exports__